import SignInPage from './components/SignInPage'

export default SignInPage
